import { useGlobalContext } from "context/GlobalContext";
import { createContext, useContext, useEffect, useState } from "react";
import { message } from "constants/responses/message";
import { taskCompletionStatusApi } from "API/apis/dashboard/taskCompletionStatus";
import { SECRETS } from "configs/secrets";
import { sseUrls } from "API/urls/sse.api";
import Cookies from "js-cookie";
import { fetchEventSource } from "@microsoft/fetch-event-source";

const TaskDashboardContext = createContext({
  tasks: [],
  setTasks: () => {},
  reloadRequired: false,
  setReloadRequired: () => {},
});

export const TaskDashboardProvider = ({ children }) => {
  const [tasks, setTasks] = useState([]);
  const [reloadRequired, setReloadRequired] = useState(false);
  const { setIsInitializing, setError, setIsLoading } = useGlobalContext();

  useEffect(() => {
    // setIsInitializing(true);
    const fetchData = async () => {
      // setIsLoading(true);
      try {
        const { data, status } = await taskCompletionStatusApi();
        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }
        setTasks(data);
      } catch (error) {
        setError(error.message);
      } finally {
        // setIsLoading(false);
        // setIsInitializing(false);
        // setReloadRequired(false);
      }
    };
    fetchData();
    const intervalId = setInterval(() => {
      fetchData();
    }, Number(SECRETS.TASK_DASHBOARD_REFRESH_TIME));
    return () => clearInterval(intervalId);
  }, [reloadRequired]);

  useEffect(() => {
    // This controller will be used to abort the fetch request if the component unmounts
    const ctrl = new AbortController();

    // The key change is here!
    fetchEventSource(SECRETS.API_URL + sseUrls.sseTaskUpdate, {
      method: "GET",
      credentials: "include",
      // signal: ctrl.signal, // This allows us to cancel the connection

      onmessage(event) {
        setReloadRequired((prev) => !prev); // functional update avoids stale closure
      },

      onerror(err) {
        console.error("EventSource failed:", err);
        throw err;
      },
    });

    // The cleanup function will run when the component unmounts
    return () => {
      console.log("Closing SSE connection.");
      ctrl.abort(); // Abort the fetch request
    };
  }, []);

  return (
    <TaskDashboardContext.Provider
      value={{
        tasks,
        setTasks,
        reloadRequired,
        setReloadRequired,
      }}
    >
      <>{children}</>
    </TaskDashboardContext.Provider>
  );
};

export const useTaskDashboardContext = () => {
  const context = useContext(TaskDashboardContext);
  if (!context) {
    throw new Error(
      "useTaskDashboardContext must be used within a TaskDashboardProvider"
    );
  }
  return context;
};
